var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "001-chat-1 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.11 25.7158C12.21 25.7158 11.355 25.2757 10.77 24.4982L8.97002 22.1511C8.97002 22.1658 8.895 22.1218 8.865 22.1218H8.31002C3.18002 22.1218 0 20.7575 0 13.9948V8.12696C0 1.95107 3.85502 0.337416 7.09502 0.0586931C7.45502 0.0146842 7.87502 0 8.31002 0H17.91C23.34 0 26.22 2.81658 26.22 8.12696V13.9948C26.22 14.4202 26.205 14.831 26.145 15.2271C25.875 18.3517 24.225 22.1218 17.91 22.1218H17.31L15.45 24.4982C14.865 25.2757 14.01 25.7158 13.11 25.7158ZM8.31002 2.20044C7.96502 2.20044 7.635 2.21511 7.32 2.24445C3.84 2.53784 2.25 4.4009 2.25 8.12696V13.9948C2.25 19.0265 3.84002 19.9213 8.31002 19.9213H8.91C9.585 19.9213 10.35 20.2881 10.77 20.8162L12.57 23.178C12.9 23.6181 13.32 23.6181 13.65 23.178L15.45 20.8308C15.885 20.2587 16.575 19.9213 17.31 19.9213H17.91C21.72 19.9213 23.625 18.3517 23.91 15.007C23.955 14.6549 23.97 14.3322 23.97 13.9948V8.12696C23.97 4.03416 22.095 2.20044 17.91 2.20044H8.31002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.1104 13.1145C12.2704 13.1145 11.6104 12.4543 11.6104 11.6475C11.6104 10.8407 12.2854 10.1805 13.1104 10.1805C13.9353 10.1805 14.6103 10.8407 14.6103 11.6475C14.6103 12.4543 13.9503 13.1145 13.1104 13.1145Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.9092 13.1145C17.0692 13.1145 16.4092 12.4543 16.4092 11.6475C16.4092 10.8407 17.0842 10.1805 17.9092 10.1805C18.7342 10.1805 19.4092 10.8407 19.4092 11.6475C19.4092 12.4543 18.7342 13.1145 17.9092 13.1145Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.32617 13.1145C7.48617 13.1145 6.82617 12.4543 6.82617 11.6475C6.82617 10.8407 7.50117 10.1805 8.32617 10.1805C9.15117 10.1805 9.82617 10.8407 9.82617 11.6475C9.82617 12.4543 9.15117 13.1145 8.32617 13.1145Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.846529520a86c4c527be72429a02e0f0.svg";
export { ForwardRef as ReactComponent };